import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LeadCard } from "./LeadCard";
import { LeadsMetrics } from "./LeadsMetrics";
import { LeadsPipeline } from "./LeadsPipeline";
import { LeadsHeader } from "./LeadsHeader";
import { LeadFormDialog } from "./LeadFormDialog";
import { useToast } from "@/components/ui/use-toast";
import { Spinner } from "@/components/ui/spinner";
import { Lead } from "./types";

export const LeadsDashboard = () => {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { toast } = useToast();

  const fetchLeads = async () => {
    try {
      const { data, error } = await supabase
        .from("quote_leads")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      setLeads(data || []);
    } catch (error: any) {
      console.error("Error fetching leads:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to load leads. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  const handleLeadAdded = (newLead: Lead) => {
    setLeads((prev) => [newLead, ...prev]);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <LeadsHeader onAddNewClick={() => setIsDialogOpen(true)} />
      <LeadsMetrics leads={leads} />
      <LeadsPipeline leads={leads} onLeadUpdated={fetchLeads} />
      
      <LeadFormDialog 
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onLeadAdded={handleLeadAdded}
      />
    </div>
  );
};